import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationMedicalLinkForm, { ReRegistrationMedicalLinkFormItem } from "../../../../forms/recadastramento/ReRegistrationMedicalLinkForm";

import AcademicService from "../../../../services/AcademicService";
import TmpInputSelectSearchCustom from "../../../../components/tempo/TmpInputSelectSearchCustom/TmpInputSelectSearchCustom";
import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";


interface ReRegistrationMedicalLinkComponentProps {
    ReRegistrationMedicalLinkForm: ReRegistrationMedicalLinkForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationMedicalLinkFormItem) => void
    onDeleteClick: (e: ReRegistrationMedicalLinkFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationMedicalLinkComponent(props: ReRegistrationMedicalLinkComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Área de Atuação", align: "center", property: "OperationArea", type: "text" },
        { title: "Número RCE", align: "center", property: "NumberRCE", type: "text" },
    ]

    const [operationAreaStateOptions, setOperationAreaStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllOperationAreaOptions().then(e => setOperationAreaStateOptions(e))
    }, []);


    return (

        <Grid container spacing={3}>


            <Grid item xs={6} sm={6}>
                <TmpInputSelectSearchCustom
                    label="Área de Atuação *"
                    name="OperationArea"
                    id="OperationArea"
                    placeholder="Selecione"
                    itens={operationAreaStateOptions}
                    value={props.ReRegistrationMedicalLinkForm.OperationArea.Value}
                    onChange={(e) => {
                        props.onInputChange("OperationArea", props.ReRegistrationMedicalLinkForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("OperationArea", props.ReRegistrationMedicalLinkForm, e.target.value);
                    }}
                    error={props.ReRegistrationMedicalLinkForm.OperationArea.HasError()}
                    helperText={props.ReRegistrationMedicalLinkForm.OperationArea.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TmpInputCustom
                    id="NumberRCE"
                    name="NumberRCE"
                    label="Número RCE"
                    maxLength={12}
                    type="text"
                    mask={InputMaskProps.NUMERICO}
                    placeholder="Digite o número RCE"
                    value={props.ReRegistrationMedicalLinkForm.NumberRCE.Value}
                    onChange={(e) => {
                        props.onInputChange("NumberRCE", props.ReRegistrationMedicalLinkForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("NumberRCE", props.ReRegistrationMedicalLinkForm, e.target.value);
                    }}
                    error={props.ReRegistrationMedicalLinkForm.NumberRCE.HasError()}
                    helperText={props.ReRegistrationMedicalLinkForm.NumberRCE.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.ReRegistrationMedicalLinkForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição vinculo médico
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationMedicalLinkForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Adicionar vinculo médico
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar vinculo médico
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationMedicalLinkForm.FormItemList}
                />
            </Grid>

        </Grid>

    )

}